/*
 * @Author: zhaosujuan zhaosujuan@freedodata.com
 * @Date: 2022-10-25 17:09:53
 * @LastEditors: zhaosujuan zhaosujuan@freedodata.com
 * @LastEditTime: 2022-11-10 13:39:29
 * @FilePath: \lyws-official-websit\src\components\index\data.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const provideServices = [
    {title:'IoT智能硬件对接',detail:'对接标准人脸闸机、摄像头、车辆道闸等社区常用硬件，实现社区智能物联。',icon:''},
    {title:'全面的物业管理功能',detail:'安保消防、绿化保洁、巡检巡查、物料设备，涵盖所有物业管理功能',icon:''},
    {title:'主流财务/票据系统对接',detail:'对接用友U8、金蝶K3、云票儿等系统，自动生成凭证，在线打印票据，减少财务工作。',icon:''},
    {title:'移动协同办公',detail:'信息线上共享，任务流转更迅速，员工办公更高效。',icon:''},
    {title:'丰富的数据统计分析',detail:'根据日常经营收费数据、房租租赁数据生成多维度统计报表，辅助管理',icon:''},
    {title:'优质的社区商城',detail:'将社区用户转变为商业流量，实现物业公司的商业转型。',icon:''},
]
export const produceList = [
    {
        name:'智慧开发区',
        children:[
            {name:'产业大屏',icon:'iconfont icon-icon-daping'},
            {name:'企业档案库',icon:'iconfont icon-icon-danganku'},
            {name:'人才数据库',icon:'iconfont icon-icon-shujuku'},
            {name:'园区大脑',icon:'iconfont icon-icon-yuanqudanao'},
            {name:'园区宣传',icon:'iconfont icon-icon-yuanquxuanchuan'},
            {name:'园区招商',icon:'iconfont icon-icon-yuanquzhaoshang'},
            {name:'资产管理',icon:'iconfont icon-icon-zichanguanli'},
            {name:'企业服务',icon:'iconfont icon-icon-qiyefuwu'},
            {name:'能耗能效',icon:'iconfont icon-icon-nenghao'},
            {name:'设施管理',icon:'iconfont icon-icon-sheshiguanli'},
            {name:'智慧通行',icon:'iconfont icon-icon-tongxing'},
            {name:'智慧安防',icon:'iconfont icon-icon-anfang'},
        ]
    },
    {
        name:'智慧园区',
        children:[
            {name:'园区大脑',icon:'iconfont icon-icon-yuanqudanao'},
            {name:'园区宣传',icon:'iconfont icon-icon-yuanquxuanchuan'},
            {name:'园区招商',icon:'iconfont icon-icon-yuanquzhaoshang'},
            {name:'资产管理',icon:'iconfont icon-icon-zichanguanli'},
            {name:'园企协同',icon:'iconfont icon-icon-xietong'},
            {name:'能耗能效',icon:'iconfont icon-icon-nenghao'},
            {name:'设施管理',icon:'iconfont icon-icon-sheshiguanli'},
            {name:'智慧通行',icon:'iconfont icon-icon-tongxing'},
            {name:'智能安防',icon:'iconfont icon-icon-anfang'},
            {name:'疫情应急管理',icon:'iconfont icon-icon-yiqingyingji'},
            {name:'企业门户',icon:'iconfont icon-icon-menhu'},
        ]
    },
    {
        name:'智慧楼宇',
        children:[
            {name:'BIM运维',icon:'iconfont icon-icon-BIMyunwei'},
            {name:'招商运营',icon:'iconfont icon-icon-zhaoshang'},
            {name:'资产管理',icon:'iconfont icon-icon-zichanguanli'},
            {name:'财务管理',icon:'iconfont icon-icon-caiwuguanli'},
            {name:'办公租赁',icon:'iconfont icon-icon-bangong'},
            {name:'客户服务',icon:'iconfont icon-icon-kefu'},
            {name:'设施管理',icon:'iconfont icon-icon-sheshiguanli'},
            {name:'智慧通行',icon:'iconfont icon-icon-tongxing'},
            {name:'智慧停车',icon:'iconfont icon-icon-tingche'},
            {name:'能耗能效',icon:'iconfont icon-icon-nenghao'},
        ]
    }
]



// WEBPACK FOOTER //
// ./src/components/index/data.js